module.exports = __webpack_public_path__ + "img/beer_id-105.afe7a564.png";